import { createContext } from "react";
import { openFileType } from "../useOpenFile";

export const StorecastShowFileContext = createContext<{
  openFile: openFileType;
}>({
  openFile: async () => {},
});
